﻿export function visa() {
    $("#bcfla-notifications").addClass("open");
}

export function hide() {
    $("#bcfla-notifications").removeClass("open");
}

export function toggle() {
    $("#bcfla-notifications").toggleClass("open");
}

export function load() {
    $("#bcfla-notifications").load(
        "/Shared/NotificationsList",
        function () {
            var anyItems = ($("#bcfla-notifications").html().length > 0);
            if (anyItems) {
                $(".bcfla-topnav-notifications-icon-holder").removeClass("bcfla-hidden");
            } else {
                $(".bcfla-topnav-notifications-icon-holder").addClass("bcfla-hidden");
                hide();
            }

            $("#bcfla-notifications .bcfla-notification-close").click(function () {
                var type = $(this).attr("data-type");
                var id = $(this).attr("data-id");

                //if (type == "1") {
                //    bcfla.agare.notes.common.toggleCompleted(id, null);
                //}
            });
        }
    );
}